import React, { useState } from 'react'
import { LanguageInput } from '../../components'
import { addAdminUnit } from '../../helper/api'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { formatLanguageCode } from '../../helper/language'

const UnitsAdd = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [language, setLanguage] = useState({
        de: '',
        el: '',
        en: '',
        es: '',
        fr: '',
        hi: '',
        it: '',
        ja: '',
        ko: '',
        pl: '',
        pt: '',
        ru: '',
        tr: '',
        zh: ''
    })

    const disabled =
        language.de.trim().length === 0 ||
        language.el.trim().length === 0 ||
        language.en.trim().length === 0 ||
        language.es.trim().length === 0 ||
        language.fr.trim().length === 0 ||
        language.hi.trim().length === 0 ||
        language.it.trim().length === 0 ||
        language.ja.trim().length === 0 ||
        language.ko.trim().length === 0 ||
        language.pl.trim().length === 0 ||
        language.pt.trim().length === 0 ||
        language.ru.trim().length === 0 ||
        language.tr.trim().length === 0 ||
        language.zh.trim().length === 0

    const addUnit = async () => {
        setLoading(true)
        const credentials = {
            name: language.tr.trim(),
            ...formatLanguageCode(language)
        }
        const { status, message } = await addAdminUnit(credentials)
        if (status) {
            toast('Birim başarıyla eklendi.', {
                type: 'success'
            })
            navigate(-1)
        } else {
            toast(message, {
                type: 'error'
            })
        }
        setLoading(false)
    }

    return (
        <div>
            <h1 className="font-bold text-3xl text-left mb-5">Birim Ekle</h1>
            <LanguageInput
                placeholder={'Birim'}
                loading={loading}
                setLoading={setLoading}
                language={language}
                setLanguage={setLanguage}
            />
            <Button
                block
                type="primary"
                icon={<PlusOutlined />}
                size={'large'}
                loading={loading}
                onClick={addUnit}
                className="mt-4 bg-blue-400"
                disabled={disabled}
            >
                Ekle
            </Button>
        </div>
    )
}

export default UnitsAdd
